module.exports = __webpack_public_path__ + "img/lens-150-minus-01.ad161a62.png";